import { getDownloadURL, ref } from 'firebase/storage';
import { storage } from '@/lib/firebase';
import { useQuery } from '@tanstack/react-query';

export function useFetchImageUrl(path: string) {
  return useQuery({
    queryKey: ['image', path],
    queryFn: async () => {
      const r = ref(storage, path);
      const url = await getDownloadURL(r);
      return url.toString();
    },
    enabled: !!path,
  });
}
